import generateImageUrl from "@/utils/generate-image-url";

const allSliders = state => state.allSliders;

const allSlidersLoading = state => state.allSlidersLoading;

const homeTrackProfile = state => state.homeTrackProfile;

const homeTrackProfileLoading = state => state.homeTrackProfileLoading;

const homeGettingStarted = state => state.homeGettingStarted;

const homeGettingStartedLoading = state => state.homeGettingStartedLoading;

const homeDetailInfo = state => state.homeDetailInfo;

const homeDetailInfoLoading = state => state.homeDetailInfoLoading;

const homeSectionInfo = state => state.homeSectionInfo;

const homeSectionInfoLoading = state => state.homeSectionInfoLoading;

const necs = state => state.necs;

const necsLoading = state => state.necs;

const formattedGettingStartedData = state => {
  return [
    {
      image: state.homeGettingStarted[0].athleteImage,
      title: "ATHLETE + FAMILIES",
      caption: state.homeGettingStarted[0].athleteDescription,
      button: [
        {
          link: "register",
          text: "Get Started"
        },
        {
          link: "player-recruiting",
          text: "Learn More"
        }
      ]
    },
    {
      image: state.homeGettingStarted[0].clubCoachImage,
      title: "CLUB COACHES",
      caption: state.homeGettingStarted[0].clubCoachDescription,
      button: [
        {
          link: "club-register",
          text: "Get Started"
        },
        {
          link: "club-recruiting",
          text: "Learn More"
        }
      ],
      class: ["blue-bg"]
    },
    {
      image: state.homeGettingStarted[0].collegeCoachImage,
      title: "COLLEGE COACHES",
      caption: state.homeGettingStarted[0].collegeCoachDescription,
      button: [
        {
          link: "college-coach-register",
          text: "Get Started"
        },
        {
          link: "college-recruiting",
          text: "Learn More"
        }
      ]
    }
  ];
};

const formattedTrackProfileData = state => {
  return [
    {
      image: "football-player.svg",
      title: "As a Player",
      description: state.homeTrackProfile.athleteDescription
    },
    {
      image: "coach.svg",
      title: "As a Club Coach",
      description: state.homeTrackProfile.clubCoachDescription
    },
    {
      image: "coach.svg",
      title: "As a College Coach",
      description: state.homeTrackProfile.collegeCoachDescription
    }
  ];
};

const formattedDetailInfo = state => ({
  title: "Detailed Profile Information",
  description: state.homeDetailInfo[0].description,
  permissions: state.homeDetailInfo[0].permission,
  sliders: [],
  steps: [
    {
      title: "Details",
      icon: "checklist.svg",
      src: generateImageUrl(state.homeDetailInfo[0].detailsImage)
    },
    {
      title: "Photos",
      icon: "football-player.svg",
      src: generateImageUrl(state.homeDetailInfo[0].photosImage)
    },
    {
      title: "Academic Information",
      icon: "online-learning.svg",
      src: generateImageUrl(state.homeDetailInfo[0].academicInfoImage)
    },
    {
      title: "Videos",
      icon: "vlog.svg",
      src: generateImageUrl(state.homeDetailInfo[0].videoImage)
    },
    {
      title: "Events",
      icon: "checklist.svg",
      src: generateImageUrl(state.homeDetailInfo[0].eventImage)
    },
    {
      title: "Highlights",
      icon: "football-player.svg",
      src: generateImageUrl(state.homeDetailInfo[0].highlightImage)
    }
  ]
});

const formattedChatInfoData = state => ({
  title: "Chat with Players, Club Coaches, and College Coaches",
  image: generateImageUrl(state.homeSectionInfo[0].chatImage),
  description: state.homeSectionInfo[0].chatDescription,
  caption: state.homeSectionInfo[0].chatPermission,
  imagelist: [generateImageUrl(state.homeSectionInfo[0].chatImage)]
});

const formattedSearchPlayersData = state => ({
  title: "Search Players",
  description: state.homeSectionInfo[0].searchplayerDescription,
  sliders: [generateImageUrl(state.homeSectionInfo[0].searchplayerImage)],
  permissions: state.homeSectionInfo[0].searchplayerPermission,
  singleImage: [generateImageUrl(state.homeSectionInfo[0].searchplayerImage)],
  steps: [
    {
      title: "Player Details",
      icon: "checklist.svg"
      // image: "http://topnotch.demo-4u.com/img/player-search.5a519b4b.jpg"
    },
    {
      title: "Player Photos",
      icon: "football-player.svg"
      // image: "http://topnotch.demo-4u.com/img/player-search.5a519b4b.jpg"
    },
    {
      title: "Academic Information",
      icon: "online-learning.svg"
      // image: "http://topnotch.demo-4u.com/img/player-search.5a519b4b.jpg"
    },
    {
      title: "Player Videos",
      icon: "vlog.svg"
      // image: "http://topnotch.demo-4u.com/img/player-search.5a519b4b.jpg"
    }
  ]
});

const formattedSearchCoachesData = state => ({
  title: "SEARCH CLUBS & COLLEGES",
  caption: state.homeSectionInfo[0].searchClbClgPermission,
  description: state.homeSectionInfo[0].searchClbClgDescription,
  image: generateImageUrl(state.homeSectionInfo[0].searchClbClgImage),
  imagelist: [generateImageUrl(state.homeSectionInfo[0].searchClbClgImage)]
});

const formattedSearchEventsData = state => ({
  title: "Search Club & College Events",
  description: state.homeSectionInfo[0].searchEventDescription,
  image: generateImageUrl(state.homeSectionInfo[0].searchEventImage),
  permissions: state.homeSectionInfo[0].searchEventPermission,
  imagelist: [generateImageUrl(state.homeSectionInfo[0].searchEventImage)]
});

const formattedNecsData = state => {
  return [
    {
      image: generateImageUrl(state.necs[0].image1),
      date: state.necs[0].date1,
      title: state.necs[0].title1,
      anchor: state.necs[0].url1
    },
    {
      image: generateImageUrl(state.necs[0].image2),
      date: state.necs[0].date2,
      title: state.necs[0].title2,
      anchor: state.necs[0].url2
    },
    {
      image: generateImageUrl(state.necs[0].image3),
      date: state.necs[0].date3,
      title: state.necs[0].title3,
      anchor: state.necs[0].url3
    },
    {
      image: generateImageUrl(state.necs[0].image4),
      date: state.necs[0].date4,
      title: state.necs[0].title4,
      anchor: state.necs[0].url4
    },
    {
      image: generateImageUrl(state.necs[0].image5),
      date: state.necs[0].date5,
      title: state.necs[0].title5,
      anchor: state.necs[0].url5
    },
    {
      image: generateImageUrl(state.necs[0].image6),
      date: state.necs[0].date6,
      title: state.necs[0].title6,
      anchor: state.necs[0].url6
    }
  ];
};

export default {
  allSliders,
  allSlidersLoading,
  homeTrackProfile,
  homeTrackProfileLoading,
  homeGettingStarted,
  homeGettingStartedLoading,
  formattedGettingStartedData,
  formattedTrackProfileData,
  homeDetailInfo,
  homeDetailInfoLoading,
  homeSectionInfo,
  homeSectionInfoLoading,
  necs,
  necsLoading,
  formattedDetailInfo,
  formattedChatInfoData,
  formattedSearchPlayersData,
  formattedSearchCoachesData,
  formattedSearchEventsData,
  formattedNecsData
};
